export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-information-line"></i>
              关于我们
            </div>

            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              成全影视 · 你的免费观影伴侣
            </h2>

            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                成全影视成立于2020年，是一家专注于提供<strong>高清免费影视</strong>资源的在线平台。我们深知影迷对优质内容的渴望，因此致力于打造一个资源丰富、体验流畅的影视聚合站点。目前平台已收录超过<strong>20000部影视作品</strong>，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。
              </p>
              <p>
                我们坚持<strong>完全免费、无需注册、免VIP</strong>的运营理念，所有内容均支持高清播放。平台采用先进的视频编码技术和全球CDN加速，确保每一位用户都能享受流畅的观影体验。同时，站点全面适配移动端，无论在家还是出行都能便捷追剧。
              </p>
              <p>
                每周新增<strong>超过100部</strong>最新影视资源，《成全影视》已经服务了数百万影迷用户。我们的内容团队持续关注各大平台的新片上线动态，第一时间为用户提供最新、最热的影视资讯和片源。
              </p>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20home%20theater%20setup%20with%20a%20large%20screen%20displaying%20cinematic%20content%2C%20soft%20ambient%20lighting%2C%20comfortable%20seating%2C%20modern%20minimalist%20decor%2C%20warm%20crimson%20and%20amber%20accents%2C%20cozy%20atmosphere%2C%20no%20people%2C%20no%20text&width=960&height=720&seq=about-cinema&orientation=landscape"
                alt="成全影视 - 温馨的家庭观影场景"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}